import { render } from "./TotalSert.vue?vue&type=template&id=0737297a&scoped=true&ts=true"
import script from "./TotalSert.vue?vue&type=script&lang=ts"
export * from "./TotalSert.vue?vue&type=script&lang=ts"

import "./TotalSert.vue?vue&type=style&index=0&id=0737297a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0737297a"]])

export default __exports__